import {Col, Row, Stack} from 'react-bootstrap'
import Dropdown from '../../../../sharedComponent/Dropdown/Dropdown'
import uuid from 'react-uuid'
import React from 'react'
type ProductSelectionType = {
  formik: any
  commodity: any
  utilities: any
  contractTypes: any
  brands: any
  products: any
  handleSelectedItem: any
  handleProductDropDownChange: any
  utilityConfig: {
    utilityFieldName: string
    utilityHeader: String
  }
  commodityConfig: {
    commodityFieldName: string
    commodityHeader: String
    isDisabled: boolean
  }
  brandConfig: {
    brandFieldName: string
    brandHeader: String
  }
  contractTypeConfig: {
    contractTypeFieldName: string
    contractTypeHeader: String
  }
  productConfig: {
    productFieldName: string
    productHeader: string
  }
}
const ProductSelection = ({
  formik,
  commodity,
  utilities,
  brands,
  contractTypes,
  products,
  handleProductDropDownChange,
  handleSelectedItem,
  commodityConfig,
  contractTypeConfig,
  brandConfig,
  utilityConfig,
  productConfig,
}: ProductSelectionType) => (
  <>
    <Row className='mb-5 d-flex align-items-end mt-5 no-gutters noPadding'>
      {Boolean(commodityConfig) && (
        <Col sm={6} md={6} className='mr-0 ml-0 p-0 pb-5 ps-3'>
          <label className='d-flex align-items-center mb-2'>
            <span className='fs-6 fw-semibold lh-23px'>{commodityConfig?.commodityHeader}</span>
          </label>
          <Dropdown
            fieldName={commodityConfig?.commodityFieldName}
            optionList={commodity}
            handleSelectedItem={handleSelectedItem}
            formik={formik}
            fieldDisabled={
              formik.values.tpvStatus === 'PENDING' ||
              formik.values.tpvStatus === 'INCOMPLETE' ||
              commodityConfig.isDisabled
            }
          />
        </Col>
      )}

      <Col sm={6} md={6} className='mr-0 ml-0 p-0 pb-5 ps-3'>
        <label className='d-flex align-items-center mb-2'>
          <span className='fs-6 fw-semibold lh-23px'>{utilityConfig.utilityHeader}</span>
        </label>
        <Dropdown
          fieldName={utilityConfig.utilityFieldName}
          optionList={utilities}
          handleSelectedItem={handleSelectedItem}
          formik={formik}
          fieldDisabled={
            formik.values.tpvStatus === 'PENDING' || formik.values.tpvStatus === 'INCOMPLETE'
          }
        />
      </Col>
    </Row>
    <Row className='mb-5 d-flex align-items-end mt-5 no-gutters noPadding'>
      <Col sm={6} md={6} className='mr-0 ml-0 p-0 pb-5 ps-3'>
        <label className='d-flex align-items-center mb-2'>
          <span className='fs-6 fw-semibold lh-23px'>{contractTypeConfig.contractTypeHeader}</span>
        </label>
        <Dropdown
          fieldName={contractTypeConfig.contractTypeFieldName}
          optionList={contractTypes}
          handleSelectedItem={handleSelectedItem}
          formik={formik}
          fieldDisabled={
            formik.values.tpvStatus === 'PENDING' || formik.values.tpvStatus === 'INCOMPLETE'
          }
        />
      </Col>
      <Col sm={6} md={6} className='mr-0 ml-0 p-0 pb-5 ps-3'>
        <label className='d-flex align-items-center mb-2'>
          <span className='fs-6 fw-semibold lh-23px'>{brandConfig.brandHeader}</span>
        </label>
        <Dropdown
          fieldName={brandConfig.brandFieldName}
          optionList={brands}
          handleSelectedItem={handleSelectedItem}
          formik={formik}
          fieldDisabled={
            formik.values.tpvStatus === 'PENDING' || formik.values.tpvStatus === 'INCOMPLETE'
          }
        />
      </Col>
    </Row>
    <Stack className='mt-5 mb-5' gap={3}>
      <label className='d-flex align-items-center mb-2 required'>
        <span className='fs-6 fw-semibold lh-23px'>{productConfig.productHeader}</span>
      </label>
      <select
        className='form-select form-select-solid'
        aria-label='Select example'
        name={productConfig.productFieldName}
        {...formik.getFieldProps(productConfig.productFieldName)}
        disabled={
          formik.values.tpvStatus === 'PENDING' ||
          formik.values.tpvStatus === 'INCOMPLETE' ||
          formik.values.tpvStatus === 'UNVERIFIED' ||
          formik.values.tpvStatus === 'FAILED'
        }
        data-toggle='tooltip'
        title={
          (formik.values.tpvStatus === 'PENDING' || formik.values.tpvStatus === 'INCOMPLETE') &&
          "product can't be changed while TPV is in pending"
        }
        onChange={(e) => handleProductDropDownChange(e, productConfig.productFieldName, products)}
      >
        <option value=''>Select product</option>
        {products?.map((_products: any) => {
          return (
            <option value={_products.id} key={uuid()}>
              {_products.name}
            </option>
          )
        })}
      </select>
      {formik.errors[productConfig.productFieldName] &&
        formik.touched[productConfig.productFieldName] && (
          <div className='fv-plugins-message-container'>
            <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
              {formik.errors[productConfig.productFieldName]}
            </div>
          </div>
        )}
    </Stack>
  </>
)

export default ProductSelection
